import * as React from "react";
import { Products } from "@grandvisionhq/api-client";
import { useApiConfig, useIntl } from "@grandvisionhq/state";
import { parseCTUpsellData } from "../../../../../../utils/utils/parse-ct-upsell-data.js";
import { UpsellItemContainer } from "./UpsellItemContainer.js";
const UpsellCategoryContainer = ({ categoryKey }) => {
  const { productsUrl } = useApiConfig();
  const { getLabel, locale } = useIntl();
  const [upsellProducts, setUpsellProducts] = React.useState([]);
  const cancelled = React.useRef(false);
  React.useEffect(() => {
    const fetchUpsellProducts = async () => {
      try {
        const { results } = await Products.query(productsUrl, {
          categoryType: categoryKey
        });
        if (cancelled.current) {
          return;
        }
        const parsedProducts = parseCTUpsellData(results, locale, getLabel);
        setUpsellProducts(parsedProducts);
      } catch (e) {
        console.error(`Error fetching upsell products ${e.message}`);
      }
    };
    fetchUpsellProducts();
    return () => {
      cancelled.current = true;
    };
  }, [productsUrl, categoryKey, setUpsellProducts]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, upsellProducts.map((product) => /* @__PURE__ */ React.createElement(UpsellItemContainer, { key: product.sku, ...product })));
};
export {
  UpsellCategoryContainer
};
//# sourceMappingURL=UpsellCategoryContainer.js.map
